import React from "react";
import { Checkbox, Dropdown, Icon } from "semantic-ui-react";
import BCSearchBox from "./ui/BCSearchBox";
import { useBCGlobalReducer } from "./BCGlobalStore";
import { GlobalConstants } from "./constants/GlobalConstants";
import "../styles/global/filter-search.scss";
import "../styles/global/filter.scss";
import BCMenuBar from "./ui/BCMenuBar";
import { arrayHasItems } from "../helpers/GlobalHelper";

const FilterSearch = ({ ...props }: any) => {
  const [{ searchValue, filtersList, isFilterOpen, dataToFilter }, dispatch]: any = props.reducerInstance || useBCGlobalReducer();

  const handleFilterToggle = () => {
    const filterAction = isFilterOpen ? GlobalConstants.BCStoreReducerCases.CLOSE_FILTER : GlobalConstants.BCStoreReducerCases.OPEN_FILTER;
    if (arrayHasItems(dataToFilter)) {
      dispatch({
        type: filterAction,
      });
    }
  };

  const handleSearchChange = (e) => {
    dispatch({
      type: GlobalConstants.BCStoreReducerCases.SET_SEARCH_VALUE,
      payload: e.target.value,
    });
  };

  const filtersListItems = filtersList?.map(({ title, isDisabled, isHidden }) => ({
    title,
    isDisabled,
    isHidden
  }));

  const handleCheckChange = ({ label, checked }: any) => {
    const updateFilterList = filtersList.map((filter) => {
      if (filter.title === label) {
        return {
          ...filter,
          isDisabled: !checked,
        };
      }
      return filter;
    });
    dispatch({
      type: GlobalConstants.BCStoreReducerCases.SET_GLOBAL_FILTERS,
      payload: updateFilterList,
    });
  };
  return (
    <div className="filter_search_container">
      <BCSearchBox
        placeHolder="Filter by keyword"
        handleChange={handleSearchChange}
        value={searchValue}
      />
      {!props.hideFilterBar && <React.Fragment>
        <div
          className="toggle-filter-button-container"
          onClick={() => handleFilterToggle()}
        >
          <Icon name="filter" disabled={!arrayHasItems(dataToFilter)}></Icon>
        </div>
        <div className="settings-button-container">
          <Dropdown icon="sliders horizontal" disabled={!arrayHasItems(dataToFilter)} multiple labeled className="icon">
            <Dropdown.Menu direction="left">
              {filtersListItems.map(({ title, isDisabled, isHidden }) => {
                if (!isHidden) {
                  return <Dropdown.Item
                    className="no_padding"
                    onClick={(e) => e.stopPropagation()}
                    key={`${title}`}
                  >
                    <Checkbox
                      label={title}
                      checked={!isDisabled}
                      onChange={(_, data) => handleCheckChange(data)}
                      className="checkbox-fill"
                    />
                  </Dropdown.Item>;
                }
              })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </React.Fragment>}
    </div>
  );
};

export default FilterSearch;

export const BCFilterSearchBar = ({...props}) => {
  const reducerInstance: any = props.reducerInstance || useBCGlobalReducer();
  return (
    <BCMenuBar
      leftChildren={[props.searchBarLeftComponent || <React.Fragment/>]}
      rightChildren={[<FilterSearch reducerInstance={reducerInstance} hideFilterBar={props.hideFilterBar}/>]}
      className={ reducerInstance[0]?.isFilterOpen ? "no-bottom-margin" : ""}
    />
  );
};